export const invitationUI = {
    namespaced: true
};
